var map = {
	"./AI.png": "8aR4",
	"./CloudDrive.png": "1tkk",
	"./CustomerService2.png": "T9WM",
	"./Discount.png": "hoda",
	"./Distribution.png": "pFkX",
	"./HarmfulInformationReporting.png": "RoGE",
	"./OnlineHarmfulInformationReportingZone.png": "eq7o",
	"./Payment.png": "zBst",
	"./Points.png": "7xXb",
	"./Product.png": "9o9h",
	"./backWhite.png": "BRT8",
	"./bottom.png": "cY24",
	"./customerService.png": "Wymx",
	"./recordAI.png": "AUJz",
	"./recordQuick.png": "i0Ks"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oFz7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont ^\.\/.*\.png$
// module id = oFz7
// module chunks = 82